document.addEventListener('DOMContentLoaded', function() {
  //  Clicking on it should load the next page using Ajax and append to the current page listing, above the load more button.
  const loadMoreButton = document.getElementById('load-more');
  const productGrid = document.getElementById('product-grid') || document.getElementById('blog-grid');
  const loadingSpinner = document.getElementById('loading-spinner');
  if (loadMoreButton && productGrid) {
    loadMoreButton.addEventListener('click', function() {
      const nextUrl = loadMoreButton.getAttribute('data-next-url');
      
      // Show loading state
      loadMoreButton.style.display = 'none';
      loadingSpinner.style.display = 'block';

      // Fetch next page
      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Get new items (products or articles)
          const gridId = productGrid.getAttribute('id');
          const newItems = doc.getElementById(gridId).innerHTML;
          
          // Append new items
          productGrid.insertAdjacentHTML('beforeend', newItems);
          
          // Check for next page
          const nextPageLink = doc.querySelector('#load-more');
          if (nextPageLink) {
            loadMoreButton.setAttribute('data-next-url', nextPageLink.getAttribute('data-next-url'));
            loadMoreButton.style.display = 'block';
          } else {
            loadMoreButton.remove(); // Remove button if no more pages
            loadingSpinner.remove();
          }
          
          // Hide loading spinner
          loadingSpinner.style.display = 'none';
        })
        .catch(error => {
          console.error('Error loading more items:', error);
          loadMoreButton.style.display = 'block';
          loadingSpinner.style.display = 'none';
        });
    });
  }
});
